import React, { Fragment } from 'react';
import './style.css';

import Header from './components/Header';
import AppointmentPage from "./components/AppointmentPage";
import ContentPlaceholder from "../ContentPlaceholder";


export class MobileApp extends React.Component {
  render() {
    return (
      <Fragment>
        <Header/>
        {
          this.props.appointmentDisabled
            ? <ContentPlaceholder/>
            : <AppointmentPage />
        }
      </Fragment>
    );
  }
}

export default MobileApp;



// WEBPACK FOOTER //
// frontend/src/modules/mobile/MobileApp.jsx